import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface ISubHeaderProps {
    data: ISubHeaderLoan
    setIsOpenLink: React.Dispatch<React.SetStateAction<boolean>>
}
export default function SubHeader({ data, setIsOpenLink }: ISubHeaderProps) {
    const navigate = useNavigate()
    return (
        <div className=" bg-white mb-2 p-3 w-full">
            <div className=" flex justify-between">
                <div></div>
                <div className=" text-xs">
                    <div className=" flex justify-between my-2">
                        <p className=" mx-2  text-base"> مبلغ وام: </p>
                        <p className="text-base">
                            {data.amount && data.amount.toLocaleString()} تومان
                        </p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" mx-2">تاریخ اعطای وام: </p>
                        <p>{data.pay_date && ConvertorMiladi(data.pay_date)}</p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" mx-2">نحوه دریافت کارمزد: </p>
                        <p>
                            {data.interest_pay_mode === 'lip_ma'
                                ? 'افزودن به هر قسط' +
                                  `(${Number(data.interest_rate) * 100} درصد)`
                                : 'کسر از مبلغ وام'}
                        </p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" mx-2">اقساط پرداخت شده :</p>
                        <p>{data.number_of_repaid_installments} قسط</p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" mx-2">اقساط باقی مانده : </p>
                        <p>{data.number_of_repayments} قسط</p>
                    </div>
                    <div className=" flex justify-between my-2">
                        <p className=" mx-2">اقساط معوق : </p>
                        <p>{data.number_of_delayed_installments} قسط</p>
                    </div>
                </div>
                <div></div>
            </div>
            <div className=" flex justify-between">
                <button
                    className=" bg-green-1 text-white py-2 rounded-md w-full text-sm "
                    onClick={() => navigate(-1)}
                >
                    اطلاعات عضو
                </button>
                {/* <button className=" bg-green-1 text-white py-2 rounded-md w-full mr-3 text-sm">
                    تنفس دهی به اقساط
                </button> */}
            </div>
            <button
                className="bg-green-1 text-white py-2 rounded-md w-full text-sm my-2"
                onClick={() => setIsOpenLink(true)}
            >
                اشتراک گذاری لینک پرداخت اقساط وام
            </button>
        </div>
    )
}
